import './GuyanaStripe.css';

export default function GuyanaStripe() {
  return <div className="guyana-stripe" aria-hidden="true" />;
}
